/* WN-TRANSITIONS — fade out/in al navegar entre páginas.
   El fade-in de entrada es CSS puro (wn-base.css); este script solo
   maneja el fade-out y su reset. Se desactiva con prefers-reduced-motion
   y en el theme editor. */
(function () {
  'use strict';

  var doc = document.documentElement;

  /* bfcache: al volver con atrás/adelante la página se restaura tal
     cual quedó — sin este reset quedaría invisible tras un fade-out. */
  window.addEventListener('pageshow', function () {
    doc.classList.remove('wn-leaving');
  });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return; /* otro componente (Dawn) ya manejó el click */
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    if (link.target && link.target !== '_self') return;
    if (link.hasAttribute('download') || link.hasAttribute('data-wn-no-transition')) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    /* ancla dentro de la misma página */
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

    event.preventDefault();
    doc.classList.add('wn-leaving');
    window.setTimeout(function () {
      window.location.href = link.href;
    }, 180);
  });
}());
